import Err from '../../models/err';

export default function createTakenError(attrName, attrs = {}) {
  return new Err({ code: Err.Code.TAKEN, attr: attrName, detail: `${attrName} is already taken`, ...attrs });
}
